import React, { useEffect, useState } from "react";
import Lookups from "../../../constants/Lookups";
import { Lookup } from "common-util-experience-client";
import { GridUsersDropdown } from "../../../grid/GridUsersDropdown";
import { GridLookupDropdown } from "../../../grid/GridLookupDropdown";
import { FilterCriteria } from "patients-experience-client";
import { UsersDto } from "users-experience-client";

interface MedicationHeaderProps {
    patientId?: string;
    offCanvasShowCallback: (comp: string) => void;
    onUpdateFilters: (filterArray: FilterCriteria[]) => void;
}

export const MedicationHeader = (props: MedicationHeaderProps) => {


    const [addedBy, setAddedBy] = useState<string[] | null>();
    const [medicationStatus, setMedicationStatus] = useState<string[]>([]);
    const [medRecStatuses, setMedRecStatuses] = useState<string[]>([]);
    const filters: FilterCriteria[] = [];
    const [searchText, setSearchText] = useState<string>();

    const updateMedicationStatus = (values: Lookup[]) => {
        setMedicationStatus(values.map(v => v.id));
    }

    const updateMedRecStatuses = (values: Lookup[]) => {
        setMedRecStatuses(values.map(v => v.id));
    }

    const updateAddedBy= (values: UsersDto[]) => {
        setAddedBy(values ? values.map(v => v.id) : null);
      }

    const updateFilters = () => {
        if (props.patientId) {
            filters.push({
              propertyName: "patientId",
              operator: "equals",
              propertyValue: props.patientId
            });
          }
          if ((searchText?.length ?? 0) > 0) {
            filters.push({
              propertyName: "medicationName",
              operator: "contains",
              propertyValue: searchText
            });
          }
        if (medicationStatus && medicationStatus.length > 0) {
            filters.push({
                propertyName: "status",
                operator: "in",
                propertyValue: medicationStatus
            });
        }
        if (medRecStatuses && medRecStatuses.length > 0) {
            filters.push({
                propertyName: "medRecStatus",
                operator: "in",
                propertyValue: medRecStatuses
            });
        }
        if (addedBy && addedBy.length > 0) {
            filters.push({
              propertyName: "addedBy",
              operator: "in",
              propertyValue: addedBy
            });
          }
        props.onUpdateFilters(filters);
    }

    useEffect(updateFilters, [addedBy, medicationStatus, medRecStatuses, props.patientId, searchText]);

    const handleOffCanvasShow = (comp: string) => {
        props.offCanvasShowCallback(comp);
    };


    return (<div className="d-md-flex align-items-center pb-3" aria-label="breadcrumb">
        <div className="flex-fill d-flex align-items-center">
            <div className="search-box max-w-md-18-75">
                <span className="material-symbols-outlined search-box__icon">
                    search
                </span>
                <input
                    type="text"
                    id="searchInput"
                    placeholder="Search Medicine"
                    className="form-control search-box__input fw-normal fs-12"
                    onChange={(event) => setSearchText(event.target.value)}
                />
            </div>
        </div>
        <div className="d-flex align-items-center flex-wrap">
            <GridLookupDropdown label="Status" type={Lookups.MEDICATION_STATUS} onChange={updateMedicationStatus}/>
            <GridLookupDropdown 
                label="Med Rec Status" 
                type={Lookups.MEDICATION_RECONCILIATION_STATUS} 
                onChange={updateMedRecStatuses}
            />
            <GridUsersDropdown
                label="Added By"
                onChange={updateAddedBy}
            ></GridUsersDropdown>

            <button
                className="btn btn-sm btn-primary rounded-pill ms-md-2 me-2 me-md-0 mt-2 mt-md-0 ps-4 pe-5 text-nowrap"
                type="button"
                onClick={() => handleOffCanvasShow("addMedication")}
            >
                <span className="material-symbols-outlined fs-16 align-text-top me-1">add</span>
                Add
          </button>
        </div>
    </div>)
}